import { betterAuthClient } from './better-auth-client'

export function createClient() {
  return {
    auth: {
      async signOut() {
        await betterAuthClient.signOut()
      },
      async getSession() {
        const { data } = await betterAuthClient.getSession()
        return { data: { session: data?.session ?? null } }
      },
    },
  }
}
